module.exports = __webpack_public_path__ + "img/mind_template_item_5_2.60eb55b3.png";